import { Tooltip } from "antd";
import EllipsisTooltipText from "./EllipsisTooltipText";



const ProductName = (props: any) => {
  const { type, post, title } = props;
  const {
    product_name,
    content_title,
    shop_title,
    table_name,
    platform,
    product_image,
  } = post;

  const renderProductName = (text: string) => {
    
    return (
      <EllipsisTooltipText text={text} />
    );
  };

  return (
    <>
      {platform === "youtube" &&
      product_image &&
      product_image !== "" ? null : platform === "MISC-content" ? (
        content_title || shop_title ? (
          renderProductName(content_title || shop_title)
        ) : null
      ) : (
        <>
          {type === "content" || type === "query-content" ? (
            content_title ? (
              renderProductName(content_title)
            ) : null
          ) : type === "MAIL" ? (
            content_title ? (
              renderProductName(content_title)
            ) : (
              renderProductName(product_name)
            )
          ) : type === "product-bank" ? (
            shop_title ? (
              renderProductName(shop_title)
            ) : (
              renderProductName(table_name)
            )
          ) : post?.shop_title ? (
            renderProductName(shop_title)
          ) : post?.content_title ? (
            renderProductName(content_title)
          ) : post?.product_name ? (
            renderProductName(product_name)
          ) : null}{" "}
        </>
      )}
    </>
  );
  // return (
  //   <>      
  //   {platform === "youtube" && product_image ? null : platform === "MISC-content" ? (
  //       content_title || shop_title ? (
  //         renderText(content_title || shop_title)
  //       ) : null
  //     ) : (
  //       <>
  //         {type === "content" || type === "query-content" ? (
  //           content_title ? (
  //             renderText(content_title)
  //           ) : null
  //         ) : type === "MAIL" ? (
  //           content_title ? (
  //             renderText(content_title)
  //           ) : (
  //             renderText(product_name)
  //           )
  //         ) : type === "product-bank" ? (
  //           shop_title ? (
  //             renderText(shop_title)
  //           ) : (
  //             renderText(table_name)
  //           )
  //         ) : post?.shop_title ? (
  //           renderText(shop_title)
  //         ) : post?.content_title ? (
  //           renderText(content_title)
  //         ) : post?.product_name ? (
  //           renderText(product_name)
  //         ) : null}
  //       </>
  //     )}
  //   </>
  // );
};

export default ProductName;
